/**
 * @author Manne Hareesh
 * @description OTAs activation component
 */
import React, { useState } from "react";
import { Button, Modal, Table, Input, Select, message } from "antd";
import { MailOutlined } from "@ant-design/icons";
import { GET_ACTIVATED_ROUTES_BY_DATES_AND_SCHEDULE_ID_URL } from "../../../utils/api-url";
import { postCall } from "../../../utils/network.util";
import { loadingAction } from "../../../actions/loading-actions";
import { useDispatch } from "react-redux";
import { ACTIVATE_IN_OTA_BY_ROUTES_URL } from "../../../utils/api-url";
import { getCities, sendTripActivateEmailToOtas } from "../../../actions/admin.action";
import { checkActionAllowed, isValidArray } from "../../../utils/utilities";
import { ACTION_SEND_OTA_EMAILS } from "../../../utils/constant";

const { Search } = Input;
const { Option } = Select;

const getAvailableRoutes = (scheduleId, dates, onSuccess = () => {}, onFailure = () => {}) => {
    return new Promise((resolve, reject) => {
        postCall(GET_ACTIVATED_ROUTES_BY_DATES_AND_SCHEDULE_ID_URL, {
            scheduleId,
            dates
        }).then((res) => {
            if (res.status === "SUCCESS") {
                if (res.payload.Status === "SUCCESS") {
                    onSuccess(res.payload.Payload.routes);
                } else {
                    onFailure(res.payload.Message);
                }
            } else {
                onFailure(res.message);
            }
        }).catch((err) => {
            onFailure(err);
        })
    })
}

export const OTAActivation = (props) => {
    const {
        scheduleId,
        dates,
        disableBtn,
        scheduleData
    } = props;

    const [open, setOpen] = useState(false);
    const [availableRoutes, setAvailableRoutes] = useState([]);
    const [selectedRoutes, setSelectedRoutes] = useState([]);
    const [searchText, setSearchText] = useState({
        origin: '',
        destination: ''
    });

    const dispatch = useDispatch();

    const setLoading = (bool) => {
        dispatch(loadingAction(bool));
    }

    const rowSelection = {
        onChange: (selectedRowKeys, selectedRows) => {
          setSelectedRoutes(selectedRows);
        },
      };

    // Handle activate in OTAs
    const handleActivateInOTAs = () => {
        if (selectedRoutes.length === 0) {
            message.warning("Please select at least one route to activate");
            return;
        }
        postCall(ACTIVATE_IN_OTA_BY_ROUTES_URL, {
            routes: selectedRoutes,
            scheduleId: scheduleData.id,
            dates,
            operatorCode: global.operatorCode
        }).then((res) => {            
            if (res.status === "SUCCESS") {
                if (res.payload.Status === "SUCCESS") {
                    message.success(res.payload.Message);
                } else {
                    message.error(res.payload.Message);
                }
            } else {
                message.error(res.message);
            }
        }).catch((err) => {
            message.error(err);
        })
    };

    // Handle email abhibus
    const handleEmailAbhibus = () => {
        if (selectedRoutes.length === 0) {
            message.warning("Please select at least one route to activate");
            return;
        }else{
            if(isValidArray(dates)&&dates.length>0){
                let routeCity = getCities(selectedRoutes);
                let operatorName = scheduleData.operator_name;
                let scheduleDescription = scheduleData.description;
                let originDestination = scheduleData.origin+' to '+scheduleData.destination;
                let departureTime = scheduleData.start_time;
                let scheduleId = scheduleData.id;
                let formatData = {routeCity, operatorName, scheduleDescription, originDestination, departureTime, dates,scheduleId};
                sendTripActivateEmailToOtas(formatData, (data) => {
                    message.success(data);
                }, (err) => {message.error(err)})
            }
            else {
                message.warning("Please select atleast one date to activate.")
            }
        }
    };

    // Get unique filter options
    const getFilterOptions = (field) => {
        return [...new Set(availableRoutes.map(route => route[field]))].map(value => ({
            text: value,
            value: value
        }));
    };

    // Custom filter dropdown with search
    const getColumnSearchProps = (dataIndex) => {
        const options = getFilterOptions(dataIndex);
        return {
            filters: options,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Input
                        placeholder={`Search ${dataIndex}`}
                        value={searchText[dataIndex]}
                        onChange={(e) => {
                            setSearchText({
                                ...searchText,
                                [dataIndex]: e.target.value
                            });
                        }}
                        style={{ marginBottom: 8, display: 'block' }}
                    />
                    <div style={{ maxHeight: 200, overflow: 'auto' }}>
                        {options
                            .filter(option => 
                                option.text.toLowerCase().includes(searchText[dataIndex].toLowerCase())
                            )
                            .map(option => (
                                <div
                                    key={option.value}
                                    style={{
                                        padding: '5px 12px',
                                        cursor: 'pointer',
                                        background: selectedKeys.includes(option.value) ? '#e6f7ff' : 'transparent'
                                    }}
                                    onClick={() => {
                                        const keys = selectedKeys.includes(option.value)
                                            ? selectedKeys.filter(key => key !== option.value)
                                            : [...selectedKeys, option.value];
                                        setSelectedKeys(keys);
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedKeys.includes(option.value)}
                                        onChange={() => {}}
                                        style={{ marginRight: 8 }}
                                    />
                                    {option.text}
                                </div>
                            ))
                        }
                    </div>
                    <div style={{ marginTop: 8, display: 'flex', justifyContent: 'space-between' }}>
                        <Button
                            type="link"
                            size="small"
                            onClick={() => {
                                clearFilters();
                                setSearchText({
                                    ...searchText,
                                    [dataIndex]: ''
                                });
                            }}
                        >
                            Reset
                        </Button>
                        <Button
                            type="primary"
                            size="small"
                            onClick={() => confirm()}
                        >
                            OK
                        </Button>
                    </div>
                </div>
            ),
            onFilter: (value, record) => record[dataIndex] === value
        };
    };

    // Table columns configuration
    const columns = [
        {
            title: 'Origin',
            dataIndex: 'origin',
            key: 'origin',
            ...getColumnSearchProps('origin')
        },
        {
            title: 'Destination',
            dataIndex: 'destination',
            key: 'destination',
            ...getColumnSearchProps('destination')
        }
    ];
    
    return (
        <div>
            <Button 
            style={{ whiteSpace: 'normal', height: 'auto', lineHeight: '20px', textAlign: 'center' }}
            className="active-in-OTAs-btn"
            disabled={disableBtn}
            onClick={() => {
                setLoading(true);
                getAvailableRoutes(scheduleId, dates, (data) => {
                    setLoading(false);
                    setAvailableRoutes(data);
                    setOpen(true);
                }, (err) => {
                    setLoading(false);
                    message.error("Failed to fetch available routes");
                });
            }}>
                Activate in<br />OTAs
            </Button>
            
            <Modal
                visible={open}
                onCancel={() => setOpen(false)}
                width={800}
                footer={null}
                title={
                    <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                        Activate Via Routes in OTAs
                    </div>
                }
            >
                <div style={{ marginBottom: '16px' }}>
                    <p style={{ color: '#666', marginBottom: '16px' }}>
                        Select via routes from the list below and click activate in OTAs.
                    </p>
                    
                    <div style={{ 
                        background: '#f5f5f5', 
                        padding: '12px', 
                        borderRadius: '4px',
                        marginBottom: '16px'
                    }}>
                        <strong>{selectedRoutes.length} Via-Routes selected ({availableRoutes.length} Total)</strong>
                    </div>

                    {/* Routes Table */}
                    <Table
                        columns={columns}
                        dataSource={availableRoutes}
                        rowKey="id"
                        pagination={false}
                        size="small"
                        scroll={{ y: 300 }}
                        rowSelection={rowSelection}
                    />

                    {/* Action Buttons */}
                    <div style={{ 
                        display: 'flex', 
                        justifyContent: 'space-between', 
                        alignItems: 'center',
                        borderTop: '1px solid #f0f0f0',
                        paddingTop: '16px'
                    }}>
                        <Button 
                            type="default" 
                            onClick={() => setOpen(false)}
                            className="exit-btn"
                            style={{ minWidth: '80px' }}
                        >
                            Close
                        </Button>
                        
                        <div style={{ display: 'flex', gap: '12px' }}>
                            <Button 
                            style={{ whiteSpace: 'normal', height: 'auto', lineHeight: '20px', textAlign: 'center' }}
                            danger
                                onClick={handleActivateInOTAs}
                                disabled={selectedRoutes.length === 0}
                                className="active-in-OTAs-btn"
                            >
                                Activate In<br />OTAs
                            </Button>
                            {checkActionAllowed(ACTION_SEND_OTA_EMAILS)&&
                            <Button 
                                type="primary" 
                                icon={<MailOutlined />}
                                onClick={handleEmailAbhibus}
                                disabled={selectedRoutes.length === 0}
                            >
                                Email abhibus
                            </Button>
                            }
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}